import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AUTH_CLIENT_TOKEN, AuthClientProvider, ENV_CONFIG, EnvConfig } from '@core';
import { from, Observable, switchMap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authClient: AuthClientProvider = inject(AUTH_CLIENT_TOKEN);
  const env: EnvConfig = inject(ENV_CONFIG);

  if (!req.url.startsWith(env.apiUrl)) {
    return next(req);
  }

  return from(authClient.getIdToken()).pipe(
    switchMap((token: string | null): Observable<HttpEvent<unknown>> => {
      const authReq: HttpRequest<unknown> = token
        ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
        : req;
      return next(authReq);
    })
  );
};
